import { MppMediaItemType } from '../enums';

export interface IMediaItemData {
  type: MppMediaItemType;
  url: string;
  label?: string;
  viewsCountLabel?: string;
  dateLabel?: string;
}
